import { IStyles } from '../../interfaces/styles';

export const classes: IStyles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
};
